const compareCard = {
    props: {
        slim: {
            type: Boolean,
            default: false
        },
        card: {
            type: Object,
            default() {
                return null;
            },
        },
        availableProducts: {
            type: Array,
            default() {
                return [];
            },
        },
        index: {
            type: Number,
            default: 0
        },
        choose: {
            type: String,
            default: ''
        },
        labelClass: {
            type: String,
        },
        labelText: {
            type: String,
        }
    },
    data(){
        return {
            select: ""
        }
    },
    template: 
    `<div class="b-product-card" :class="[emptyClass, slimClass]" :style="{ backgroundImage: 'url(' + cardBg + ')' }">
    <div class="b-product-card__head-wrap">
        <div v-if="card && card.tpTl && card.tpTl !==''" class="b-product-card__head" v-html="card.tpTl"></div>
        <div v-else class="b-product-card__head"><span></span></div>
        <select class="form-select" v-model="select" @change="productChanged">
            <option value="">{{choose}}</option>
            <option v-for="item in availableProducts" :value="item.id">{{item.lbl}}</option>
        </select>
    </div>
    <div v-if="!slim" class="b-product-card__conts">
        <div v-if="card && card.tl" class="b-product-card__title">{{card.tl}}</div>
        <div v-else class="b-product-card__sympol-plus"></div>
    </div>
    <span v-if="card && card.prNotifClass && card.prNotifText" class="e-pr-notif" :class="card.prNotifClass">{{
        card.prNotifText }}</span>
</div>`,
    computed: {
        emptyClass(){
            return !this.card ? 'b-product-card--empty' : ''
        },
        slimClass(){
            if(this.slim){
                return "b-product-card--no-height"
            }
            return ''
        },
        cardBg() {
            if(!this.slim){
                if (this.card !== null && this.card.bg && this.card.bg !== "") {
                    return this.card.bg;
                }
            }
            return "";
        },
        productChanged(){
            if(this.select!=='')
                this.$emit("productChanged", this.select, this.card, this.index)
        }
    }
}